import * as Flickity from 'flickity';

export class HeroBanner {
    private container: JQuery;
    private slider: JQuery;


    /**
     * Creates a new instance of SplitScreen
     *
     * @param container The containing element
     */
    constructor(container: HTMLElement) {
        this.container = $(container);
        this.slider    = this.container.find('.js-hero-banner__slides');

        this.createCarousel();
    }


    /**
     * Initializes Flickity for the carousel.
     *
     * @private
     * @memberof SplitScreen
     */
    protected createCarousel(): void {
        new Flickity(this.slider.get(0), {
            wrapAround: true,
            setGallerySize: false,
            prevNextButtons: false
        });
    }
}
